var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#D5C9B9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0001,
    cy: 10,
    r: 6.42857,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 17.1429C13.9385 17.1429 17.1428 13.9386 17.1428 10C17.1428 6.06142 13.9385 2.85714 9.99996 2.85714C6.06139 2.85714 2.85711 6.06142 2.85711 10C2.85711 13.9386 6.06139 17.1429 9.99996 17.1429ZM10 4.28574C13.1507 4.28574 15.7143 6.84932 15.7143 10C15.7143 13.1507 13.1507 15.7143 10 15.7143C6.84929 15.7143 4.28571 13.1507 4.28571 10C4.28571 6.84932 6.84929 4.28574 10 4.28574ZM10 9.28575C9.605 9.28575 9.28571 9.60503 9.28571 10V12.8572C9.28571 13.2522 9.605 13.5715 10 13.5715C10.395 13.5715 10.7143 13.2522 10.7143 12.8572V10C10.7143 9.60503 10.395 9.28575 10 9.28575ZM10.0001 7.92832C10.4336 7.92832 10.7858 7.57689 10.7858 7.14261C10.7858 6.70904 10.4336 6.35761 10.0001 6.35761C9.5665 6.35761 9.21436 6.70904 9.21436 7.14261C9.21436 7.57689 9.5665 7.92832 10.0001 7.92832Z",
    fill: "#846E52"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.83500900596e24e7b6aa4d3cfdddecf1.svg";
export { ForwardRef as ReactComponent };